import api from "./api";
const svc = {
  preview:  (p)    => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/prestacao-contas/preview?${qs}`); },
  listar:   (p)    => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/prestacao-contas?${qs}`); },
  criar:    (data) => api("POST","/prestacao-contas",data),
  imprimir: (id)   => api("GET", `/prestacao-contas/${id}/imprimir`),
  publicar: (id)   => api("POST",`/prestacao-contas/${id}/publicar`,{}),
  enviar:   (id,canal) => api("POST",`/prestacao-contas/${id}/enviar`,{canal}),
};
export default svc;
